<div
    *ngIf="item?.layoutType === 'category-tab-section-v2'"
    class="common-layout-container-desktop"
    ngClass.xs="common-layout-container-mobile"
    [ngStyle]="sharedLayoutsService.getStyles(item?.layoutContent?.padding)"
>
    <div
        *ngIf="item?.layoutContent"
        class="category-tab-section-v2-headers"
        ngClass.xs="category-tab-section-v2-headers-mobile"
    >
        <div
            *ngIf="
                item?.layoutContent?.title?.text ||
                tabData?.categoryTab?.button?.title?.text
            "
            fxLayout
            fxLayoutAlign="space-between end"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="layout-heading"
                [style]="{ color: item?.layoutContent?.title?.color }"
            >
                {{ item?.layoutContent?.title?.text }}
            </h1>
            <a
                fxHide.gt-xs
                *ngIf="tabData?.categoryTab?.button?.title?.text"
                class="view-all-button"
                [routerLink]="[
                    tabData?.categoryTab?.button?.link | pageIdFromLink
                ]"
                [queryParams]="
                    tabData?.categoryTab?.button?.link | queryParamFromLink
                "
                [attr.aria-label]="
                    tabData?.categoryTab?.button?.title?.text || 'banner-link'
                "
                [style]="{
                    color: tabData?.categoryTab?.button.title?.color,
                    paddingRight: '16px'
                }"
            >
                {{ tabData?.categoryTab?.button?.title?.text }}
            </a>
        </div>
        <div
            *ngIf="item?.layoutContent?.feed?.length > 0"
            fxLayout="row"
            fxLayout.xs
            fxLayoutAlign="space-between end"
            style="margin: 16px 0"
        >
            <mat-tab-group
                [animationDuration]="0"
                [selectedIndex]="selectedTab"
                [disableRipple]="true"
                [disablePagination]="true"
                [@.disable]="true"
            >
                <mat-tab *ngFor="let tab of item?.layoutContent?.feed" disabled>
                    <ng-template mat-tab-label>
                        <span
                            *ngIf="!isBot && tab.title.text"
                            class="tab-header"
                            (click)="processLink(tab.link)"
                            >{{ tab.title.text }}
                        </span>
                        <a
                            *ngIf="isBot && tab.title.text"
                            class="tab-header"
                            style="text-decoration: none"
                            [routerLink]="[
                                tab?.categoryTab?.button?.link | pageIdFromLink
                            ]"
                            [queryParams]="
                                tab?.categoryTab?.button?.link
                                    | queryParamFromLink
                            "
                            [attr.aria-label]="
                                tab?.title?.text || 'button-link'
                            "
                            >{{ tab.title.text }}
                        </a>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
            <div fxHide.gt-xs ngClass.xs="color-shade"></div>
            <a
                fxHide.xs
                *ngIf="tabData?.categoryTab?.button?.title?.text"
                class="view-all-button"
                [routerLink]="[
                    tabData?.categoryTab?.button?.link | pageIdFromLink
                ]"
                [queryParams]="
                    tabData?.categoryTab?.button?.link | queryParamFromLink
                "
                [attr.aria-label]="
                    tabData?.categoryTab?.button?.title?.text || 'banner-link'
                "
                [style]="{
                    color: tabData?.categoryTab?.button.title?.color,
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-end'
                }"
            >
                {{ tabData?.categoryTab?.button?.title?.text }}
            </a>
        </div>
    </div>

    <div *ngIf="!showShimmer">
        <swiper
            [slidesPerView]="4"
            [slidesPerGroup]="4"
            [speed]="1300"
            [navigation]="true"
            [spaceBetween]="16"
            [pagination]="false"
            class="category-tab-section-v2-swiper"
            fxHide.xs="true"
            *ngIf="tabData?.categoryTab?.productList?.length > 0"
        >
            <ng-template
                swiperSlide
                *ngFor="let feedItem of tabData?.categoryTab?.productList"
            >
                <div #swiperSlide>
                    <div *ngIf="feedItem?.banner" class="swiper-card">
                        <a
                            *ngIf="feedItem?.banner?.image"
                            [routerLink]="[
                                feedItem?.banner?.link | pageIdFromLink
                            ]"
                            [queryParams]="
                                feedItem?.banner?.link | queryParamFromLink
                            "
                            [attr.aria-label]="
                                feedItem?.title?.text || 'banner-link'
                            "
                            [style]="{
                                cursor:
                                    feedItem?.banner?.link &&
                                    feedItem?.banner?.link !== ''
                                        ? 'pointer'
                                        : 'auto'
                            }"
                        >
                            <picture *ngIf="feedItem?.banner?.image">
                                <img
                                    *ngIf="feedItem?.banner?.image"
                                    class="image"
                                    src="{{ feedItem?.banner?.image }}"
                                    [alt]="feedItem?.title?.text || 'banner'"
                                />
                            </picture>
                        </a>
                    </div>
                    <h1
                        *ngIf="feedItem?.title?.text"
                        class="title truncate-text-single-line"
                        ngClass.xs="title__mobile"
                        [style]="{ color: feedItem?.title?.color }"
                        >{{ feedItem.title?.text }}</h1
                    >
                </div>
            </ng-template>
        </swiper>

        <app-custom-scrollbar
            scrollbarClass="hp-custom-scrollbar"
            scrollContainerSelector=".categorytab-cards-row"
        >
            <div
                #categoryCards
                fxLayout="row"
                *ngIf="tabData?.categoryTab?.productList?.length > 0"
                [ngStyle.xs]="{
                    display: 'flex',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    gap: '16px'
                }"
                fxHide.gt-xs="true"
                class="categorytab-cards-row"
                ngClass.xs="categorytab-cards-row-mobile"
            >
                <div
                    fxLayout="column"
                    *ngFor="let feedItem of tabData?.categoryTab?.productList"
                    [ngStyle.xs]="{
                        flex: '0 0 67.966%',
                        margin: '0 0 16px 0'
                    }"
                >
                    <a
                        *ngIf="feedItem?.banner?.image"
                        [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedItem?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            feedItem?.title?.text || 'banner-link'
                        "
                        style="margin-bottom: 8px"
                        [style]="{
                            pointerEvents:
                                feedItem?.banner?.link &&
                                feedItem?.banner?.link !== ''
                                    ? 'auto'
                                    : 'none'
                        }"
                    >
                        <img
                            *ngIf="feedItem?.banner?.image"
                            [src]="feedItem?.banner?.image"
                            alt="{{ feedItem.title?.text }}"
                            appImageCDNWithOutHeight
                            [style]="{ minHeight: '260px' }"
                        />
                    </a>
                    <h1
                        *ngIf="feedItem?.title?.text"
                        class="title truncate-text-single-line"
                        ngClass.xs="title__mobile"
                        [style]="{ color: feedItem?.title?.color }"
                        >{{ feedItem.title?.text }}</h1
                    >
                </div>
            </div>
        </app-custom-scrollbar>
    </div>

    <div *ngIf="showShimmer">
        <div
            fxHide.xs="true"
            [style.height]="swiperSlideHeight"
            [ngClass]="{ 'image-swiper-shimmer': showShimmer }"
        >
            <div class="shimmer-slide"></div>
            <div class="shimmer-slide"></div>
            <div class="shimmer-slide"></div>
            <div class="shimmer-slide"></div>
        </div>
        <div
            fxHide.gt-xs="true"
            [style.height]="categoryCardsHeight"
            [ngClass]="{ 'category-slider-shimmer': showShimmer }"
        >
            <div class="shimmer-slide"></div>
            <div class="shimmer-slide"></div>
        </div>
    </div>
</div>
